import { StylePropertiesTypes } from '@wix/document-services-types'
import type { Spx } from '@wix/thunderbolt-becky-types'
import { atomicStylePropsConverterMap } from '../../atomics/atomicPropsToCss'
import _ from 'lodash'

/** Internal Converters */
const mathOperationConverter = (styleProp: StylePropertiesTypes.MathOperation): string => {
	return `${styleProp.value}`
}

const mathValueToResolvedString = (
	prop: StylePropertiesTypes.MathFunctionValueTypes | StylePropertiesTypes.MathOperation,
	spx?: Spx
) => mathFunctionValuesTypeToConverter[prop.type](prop, spx)

const mathFunctionCommonConverter = (styleProp: StylePropertiesTypes.MathFunction, spx?: Spx): string => {
	const convertedValues = styleProp.values.map((functionValue: StylePropertiesTypes.MathFunctionValueTypes) => {
		return mathValueToResolvedString(functionValue, spx)
	})
	const joinSeparator = styleProp.function === 'calc' ? ' ' : ','
	return `${styleProp.function}(${convertedValues.join(joinSeparator)})`
}

/** External Mapper */
export const mathConverterMap = {
	MathFunction: mathFunctionCommonConverter,
	Operation: mathOperationConverter,
}

/** Internal Maps */
const mathFunctionValuesTypeToConverter = _.mergeWith(
	{ ...mathConverterMap },
	{ ...atomicStylePropsConverterMap }
) as Record<
	string,
	(prop: StylePropertiesTypes.MathFunctionValueTypes | StylePropertiesTypes.MathOperation, spx?: Spx) => string
>
